import { useNavigate, useParams } from 'react-router-dom';

import { ConfirmNavigateModal } from '~/components/organisms/ConfirmNavigateModal';
import { InitialEmptyScreen } from '~/components/organisms/previewBar/components/InitialEmptyScreen';
import { SelectQrType } from '~/components/organisms/SelectQrType/SelectQrType';
import { QRCODE_STATIC_STEP } from '~/constants/qr-code';
import { PATH } from '~/constants/route-path';
import useQrCodeData from '~/hooks/useQrCodeData';
import { StaticQrContentLayout } from '~/pages/qrBuilder/p-static/components/static-qr-content-layout/StaticQrContentLayout';
import { StaticQrCodeData } from '~/types/qrCode';

export const EditStaticType = () => {
  const navigate = useNavigate();
  const params = useParams();

  const { data: qrCode } = useQrCodeData<StaticQrCodeData>({ qrCodeId: params.id });

  const handleChangeStaticType = (type) => {
    navigate(PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.CONTENT, type, params.id));
  };

  const handleClickStep = async (step: number) => {
    if (step === 1) navigate(PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.CONTENT, params.type, params.id));
    if (step === 2) navigate(PATH.QR.EDIT_QR_STATIC(QRCODE_STATIC_STEP.STYLES, params.type, params.id));
  };

  return (
    <>
      <StaticQrContentLayout
        handleStep={handleClickStep}
        activeStep={0}
        qrCode={qrCode}
        mockup={<InitialEmptyScreen />}
        form={
          <SelectQrType
            isShowAlert
            onStaticQrTypeClick={handleChangeStaticType}
            onDynamicQrTypeClick={() => {}}
            isDynamicDisabled
          />
        }
      />

      <ConfirmNavigateModal activeStep={0} />
    </>
  );
};
